import { Injectable } from '@angular/core';
import * as _ from 'lodash';

const permLevelSiteAdmin = 1,
    permLevelProjectAdmin = 99,
    permLevelAdmin = 2,
    permLevelRead = 1,
    permLevelNoAccess = 0;

@Injectable()
export class ReleaseModel {

    public init = {
        id: 0,
        releaseName: '',
        releaseNotes: '',
        changes: '',
        rel: { tisummary: { tracker_items_count: 0 } }
    };

    public statusOptions = {
        fieldName: false,
        fieldElements: [
            { id: 'N', label: 'Not Released', defaultSelected: true },
            { id: 'Y', label: 'Released', defaultSelected: false }
        ]
    };

    public packageOptions = {
        fieldName: false,
        fieldElements: [
            { id: 0, label: 'Select a package...', defaultSelected: true }
        ]
    };

    public errorTypes = {
        uniqueReleaseName: 'Release name already exists.',
        length: 'Release name length must be 4 characters min. and 15 characters max.',
        required: 'Required.'

    };

    public data: any = {
        releaseNotes: '',
        changes: ''
    };

    public errors: any = {};

    getDownloadCount(rel) {
        var f = _.get(rel, 'rel.files', []);
        if (!f.length) {
            return 'N/A';
        }

        return _.sumBy(f, 'downloadCount');
    }

    resetErrors() {
        this.errors = _.cloneDeep(this.init);
    }
}
